var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 655,
    viewBox: "0 0 655 655",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.896 8.95508H150.104C67.3558 8.95508 0 76.2836 0 159.059V404.684C0 487.46 67.3558 554.788 150.104 554.788H183.946L282.196 637.509C295.269 649.108 311.644 654.84 327.882 654.84C343.766 654.84 359.486 649.327 371.712 638.465L472.91 554.788H504.896C587.644 554.788 655 487.46 655 404.684V159.059C655 76.2836 587.644 8.95508 504.896 8.95508ZM573.125 404.684C573.125 442.292 542.531 472.913 504.896 472.913H458.173C448.648 472.913 439.423 476.243 432.082 482.302L327.609 568.734L225.293 482.547C217.897 476.325 208.563 472.913 198.902 472.913H150.104C112.469 472.913 81.875 442.292 81.875 404.684V159.059C81.875 121.451 112.469 90.8301 150.104 90.8301H504.896C542.531 90.8301 573.125 121.451 573.125 159.059V404.684Z",
    fill: "#5E5E5E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.741,
    cy: 280.806,
    r: 40.2979,
    fill: "#5E5E5E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 476.538,
    cy: 280.806,
    r: 40.2979,
    fill: "#5E5E5E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.14,
    cy: 280.806,
    r: 40.2979,
    fill: "#5E5E5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage2);
export default __webpack_public_path__ + "static/media/message-2.a1851cfe20f0c74a7f405691c72a817b.svg";
export { ForwardRef as ReactComponent };